import React, { Component } from 'react'
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom'
import Header from '../components/Header'
import MainPage from '../containers/MainPage'
import PageSolutions from '../containers/PageSolutions'
import PageServices from '../containers/PageServices'
import PageProducts from '../containers/PageProducts'
import PageAboutUs from '../containers/PageAboutUs'
import PagePrivacyPolicy from '../containers/PagePrivacyPolicy'
import PageTermsOfService from '../containers/PageTermsOfService'

const Routes = () => (
  <Router>
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Header />
      <Switch>
        <Route
          path="/privacy-policy"
          children={() => {
            window.scrollTo(0, 0)
            return <PagePrivacyPolicy />
          }}
        />
        <Route
          path="/terms-of-service"
          children={() => {
            window.scrollTo(0, 0)
            return <PageTermsOfService />
          }}
        />

        <Route
          path="/products"
          children={() => {
            window.scrollTo(0, 0)
            return <PageProducts />
          }}
        />
        <Route
          path="/solutions"
          children={() => {
            window.scrollTo(0, 0)
            return <PageSolutions />
          }}
        />
        <Route
          path="/services"
          children={() => {
            window.scrollTo(0, 0)
            return <PageServices />
          }}
        />
        <Route
          path="/about_us"
          children={() => {
            window.scrollTo(0, 0)
            return <PageAboutUs />
          }}
        />
        <Route
          path="/"
          children={() => {
            window.scrollTo(0, 0)
            return <MainPage />
          }}
        />
        <Route render={() => <Redirect to="/" />} />
      </Switch>
    </div>
  </Router>
)

export default Routes
